import React, { useState } from 'react';
import { Modal, Button, Input, Label } from 'semantic-ui-react';
import { toast } from 'react-toastify';

const IframePasswordModal = ({
  loading,
  showPasswordModal,
  togglePasswordModal,
  getIframe
}) => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  return (
    <Modal
      open={showPasswordModal}
      onClose={
        !loading
          ? togglePasswordModal
          : () => {
              return null;
            }
      }
      size="tiny"
      dimmer="inverted"
    >
      <Modal.Header>This Insights Preview is Locked</Modal.Header>
      <Modal.Content>
        <Label
          basic
          size="large"
          icon="info circle"
          content="Enter the password to unlock it"
          style={{ border: 'none' }}
        />
        <br />
        <Input
          fluid
          disabled={loading}
          value={password}
          size="large"
          labelPosition="right"
          type={showPassword ? 'text' : 'password'}
          onChange={(event, { value }) => setPassword(value)}
          label={
            <Button
              onClick={() => {
                setShowPassword(!showPassword);
              }}
              icon={showPassword ? 'eye slash' : 'eye'}
            />
          }
        />
      </Modal.Content>
      <Modal.Actions>
        <Button
          content="Cancel"
          disabled={loading}
          onClick={togglePasswordModal}
        />
        <Button
          primary
          content="Submit"
          loading={loading}
          disabled={loading}
          onClick={() => {
            if (password) {
              getIframe(password, false);
            } else {
              toast.warn('Enter a password to continue', {
                position: 'bottom-center',
                autoClose: 2500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
              });
            }
          }}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default IframePasswordModal;



// WEBPACK FOOTER //
// ./src/screens/InsightsPreview/IframePasswordModal.jsx